@let isArabic = isArabic$ | async;
@let isLogingIn = isLogingIn$ | async;
@let isLoading = isLoading$ | async;

<div class="app-container d-flex flex-column vh-100" [ngClass]="isArabic ? 'rtl-mode' : 'ltr-mode'">
  <!-- Header -->
  <header #navbar class="navbar navbar-expand-lg bg-main px-3 fixed-top">
    <div class="container-fluid">
      <!-- Left: Logo -->
      <a class="d-flex align-items-center cursor-pointer" (click)="goToPage('/')">
        <img loading="lazy" src="logo.svg" alt="Logo" height="30" class="cursor-poiner" />
      </a>

      <!-- Toggler (burger button) -->
      <button
        class="navbar-toggler bg-primary"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        (click)="toggleNavbar()"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Collapsible content -->
      <div
        class="collapse navbar-collapse justify-content-between"
        id="navbarSupportedContent"
        [class.show]="isNavbarOpen"
      >
        <!-- Center: Nav links -->
        <ul class="navbar-nav mx-auto mb-2 mb-lg-0 nav-underline text-center">
          <li class="nav-item">
            <a
              routerLink="/"
              class="nav-link"
              aria-current="page"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              >{{ 'MENU_HOME' | translate }}</a
            >
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="searchDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ 'MENU_SEARCH_AD' | translate }}
            </a>
            <ul class="dropdown-menu bg-black text-center" aria-labelledby="searchDropdown">
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/cars"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                >
                  {{ 'SEARCH_CAR_AD' | translate }}
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/properties"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                >
                  {{ 'SEARCH_PROPERTY_AD' | translate }}
                </a>
              </li>
              <li class="nav-item">
                <a
                  routerLink="/users"
                  class="dropdown-item"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  >{{ 'MENU_USERS' | translate }}</a
                >
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="addDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ 'MENU_ADD_AD' | translate }}
            </a>
            <ul class="dropdown-menu bg-black text-center" aria-labelledby="addDropdown">
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/add-car/0"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                >
                  {{ 'ADD_CAR_AD' | translate }}
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/add-property/0"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                >
                  {{ 'ADD_PROPERTY_AD' | translate }}
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <a
              routerLink="/faq"
              class="nav-link"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              >{{ 'MENU_FAQ' | translate }}</a
            >
          </li>
          <li class="nav-item">
            <a
              routerLink="/about-us"
              class="nav-link"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              >{{ 'MENU_ABOUT_US' | translate }}</a
            >
          </li>
          <li class="nav-item">
            <app-language-switcher class="d-flex justify-content-center"></app-language-switcher>
          </li>
        </ul>

        <!-- Right: User section -->
        <div class="d-flex justify-content-end">
          @if (isLoggedIn) {
            <span class="me-3 text-primary d-flex align-items-center"
              >{{ 'MENU_WELCOME' | translate }}, {{ username }}</span
            >
          }
          @if (isLoading || isLogingIn) {
            <app-loading class="align-content-center" [height]="20"></app-loading>
          }

          <div>
            <a
              class="btn btn-sm d-flex align-items-center btn-user-menu position-relative"
              href="#"
              role="button"
              id="userMenu"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              @if (isUserBlocked || isUserPending) {
                <span class="position-absolute top-0 translate-middle badge rounded-pill bg-danger">
                  i
                  <span class="visually-hidden">unread messages</span>
                </span>
              }
              <i class="bi bi-person-square" style="font-size: 1.2rem"> </i>
            </a>

            <ul class="dropdown-menu user-menu-ul" [ngClass]="isArabic ? 'rtl-mode' : 'ltr-mode dropdown-menu-end'">
              @if (isLoggedIn) {
                <li>
                  <a
                    class="dropdown-item"
                    routerLink="/users/{{ userId }}"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    >{{ 'USER_MY_ACCOUNT' | translate }}
                    @if (isUserBlocked || isUserPending) {
                      <span class="badge rounded-pill bg-danger">
                        i
                        <span class="visually-hidden">unread messages</span>
                      </span>
                    }
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    routerLink="/saved-searches"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    >{{ 'SAVED_SEARCH.title' | translate }}</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    routerLink="/blocked-agents"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    >{{ 'BLOCKED_AGENTS' | translate }}</a
                  >
                </li>
                <li *hasRole="[roles.Admin, roles.Editor]">
                  <a
                    class="dropdown-item"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    routerLink="/reports"
                    >{{ 'REPORT_SEARCH_TITLE' | translate }}</a
                  >
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <a
                    class="dropdown-item text-danger"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    (click)="logout()"
                    >{{ 'MENU_LOGOUT' | translate }}</a
                  >
                </li>
              } @else {
                <li>
                  <a
                    routerLink="/login"
                    class="dropdown-item"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    >{{ 'MENU_LOGIN' | translate }}</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/register"
                    class="dropdown-item"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    >{{ 'MENU_REGISTER' | translate }}</a
                  >
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>

  <div class="d-flex flex-grow-1">
    <!-- Main Content -->
    <main class="flex-grow-1 my-4 overflow-auto container">
      <app-email-verification></app-email-verification>
      @if (isLogingIn || isLoading) {
        <div class="text-center my-3">
          <app-loading></app-loading>
        </div>
      } @else {
        <router-outlet></router-outlet>
        <app-scroll-to-top></app-scroll-to-top>
      }
    </main>
  </div>

  <!-- Footer -->
  <app-footer></app-footer>
</div>
